import React, { Component } from 'react';
import './TextArea.scss';

const TextArea = (props) => {
	/**
	 * Callback for whenever the value of the textarea changes.
	 */
    const handleChange = (e) => props.handleChange(e.target.value);

    return (
        <textarea
            className='text-area'
            name='main textarea'
            onChange={handleChange}
            placeholder={props.placeholderText}
            type='text'
            value={props.textValue}
        />
    );
};

export default TextArea;



// WEBPACK FOOTER //
// ./application/components/TextArea/TextArea.jsx